export enum ServicingType {
    RELEASED = 'RELEASED',
    RETAINED = 'RETAINED'
}

export const servicingTypeDisplay = {
    [ServicingType.RELEASED]: 'Released',
    [ServicingType.RETAINED]: 'Retained'
};
